import Calculator from '@/components/Calculator/Calculator';
import store from '@/store';
import { configureAppEcho, type AppWebSocketConfig } from '@/utils/echo';
import { useEcho } from '@laravel/echo-react';
import { TransactionOutlined } from '@ant-design/icons';
import { FloatButton, notification } from 'antd';
import { Suspense, useCallback, useState } from 'react';
import { Provider } from 'react-redux';
import { GlobalConfigProvider, ImagePreview, OssModule } from './components/RootContainer';

interface MessageData {
  broadcastTime: string;
  defaultData: any[];
  message: string;
  messageTitle: string;
  message_type: '1' | '2' | '3';
  type: string;
}

const webSocketConfig = (window as Window & { WEBSOCKETCONFIG: AppWebSocketConfig }).WEBSOCKETCONFIG;

// const source = new EventSource('http://192.168.1.154:8700/api/events/user/123');
//
// source.onmessage = (event) => {
//   const data = JSON.parse(event.data);
//   console.log('📥 工作流更新：', data);
//
//   // 这里可以更新前端的任务状态
//   // updateWorkflowUI(data);
// };
//
// source.onerror = (err) => {
//   console.error('SSE 出错', err);
// };

export const FLOW_UPDATE_EVENT = 'FLOW_UPDATE_EVENT';

const EchoMessageListener = ({ channel, token }: { channel: string; token?: string | null }) => {
  configureAppEcho(webSocketConfig, token);

  const handleMessage = useCallback((data: MessageData) => {
    console.log('Received message:', data);

    // 触发自定义事件，供特定页面监听
    const event = new CustomEvent(FLOW_UPDATE_EVENT, { detail: data });
    window.dispatchEvent(event);

    // 根据消息类型选择不同的通知类型
    const notificationConfig = {
      message: data.messageTitle,
      description: (
        <div>
          <div>{data.message}</div>
          <div style={{ marginTop: 8, fontSize: '12px', color: '#999' }}>时间：{data.broadcastTime}</div>
        </div>
      ),
      duration: 4.5,
      placement: 'topRight' as const,
    };

    switch (data.message_type) {
      case '1':
        notification.success(notificationConfig);
        break;
      case '2':
        notification.error(notificationConfig);
        break;
      case '3':
        notification.info(notificationConfig);
        break;
      default:
        notification.open(notificationConfig);
    }
  }, []);

  useEcho<MessageData>(`default_message.${channel}`, '.default.message', handleMessage);

  return null;
};

/**
 * 根组件容器
 * @param container - 需要包裹的主内容组件
 * @returns 带有状态管理和全局配置的组件树
 */
export default ({ container }: any) => {
  const [showCalculator, setShowCalculator] = useState(false);
  const token = store.getState().user.token;
  const channel = store.getState().user.user_info.channel;

  return (
    <Provider store={store}>
      {/* 提供Redux store */}
      <GlobalConfigProvider>
        {channel && webSocketConfig ? <EchoMessageListener channel={channel} token={token} /> : null}

        <FloatButton
          icon={<TransactionOutlined />}
          type="primary"
          style={{ insetInlineEnd: 24 }}
          onClick={() => setShowCalculator(!showCalculator)}
        />

        {showCalculator && (
          <div
            style={{
              zIndex: 10000,
              position: 'absolute',
              top: '50%',
              left: '20%',
              transform: 'translate(-50%, -50%)',
            }}
          >
            <Calculator onClose={() => setShowCalculator(false)} />
            {
              // <GlobalDragUpload />
            }
          </div>
        )}
        {/* 全局配置提供器 */}
        <Suspense fallback={'loading'}>
          {/* 懒加载时的加载提示 */}
          {container}
          <ImagePreview /> {/* 图片预览组件 */}
          <OssModule /> {/* 对象存储模块 */}
        </Suspense>
      </GlobalConfigProvider>
    </Provider>
  );
};
